import { defineNuxtRouteMiddleware } from 'nuxt/app'

import { isCPAuthRoutePath } from '../utils/auth-route.utils'

/**
 * Auth routes own a full-screen layout. Disable transitions at this boundary so
 * Nuxt does not retain the previous layout wrapper while auth content enters.
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const isEnteringOrLeavingAuth = isCPAuthRoutePath(to.path) !== isCPAuthRoutePath(from.path)

  if (isEnteringOrLeavingAuth) {
    to.meta.layoutTransition = false
    to.meta.pageTransition = false
  }
})
